import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import NewsletterPopup from "./components/newsletter/NewsletterPopup";
import ExitPopup from "./components/newsletter/ExitPopup"

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <>
          <AppRoutes />
          <NewsletterPopup />
          <ExitPopup />
        </>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
